// Ouvre le formulaire de paiement web intégré (Mollie) et attend son résultat
export const openMollieCheckout = (sku, isSubscription) =>
  new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent("mollie-checkout:open", { detail: { sku, isSubscription, resolve } }));
  });

const scripts = {};
export const loadScript = (src) => {
  if (!scripts[src]) {
    scripts[src] = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => { delete scripts[src]; reject(new Error("script")); };
      document.head.appendChild(s);
    });
  }
  return scripts[src];
};

let mollieInstance = null;
export const getMollie = async (profileId, testmode, locale) => {
  await loadScript("https://js.mollie.com/v1/mollie.js");
  if (!mollieInstance) mollieInstance = window.Mollie(profileId, { locale, testmode });
  return mollieInstance;
};

const authJson = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("session_token")}`,
});

export const molliePost = async (url, body) => {
  const r = await fetch(url, { method: "POST", headers: authJson(), body: body ? JSON.stringify(body) : undefined });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.detail || "Erreur");
  return data;
};

const AMOUNTS = {
  credits_pack_small: "4.99", credits_pack_medium: "9.99", credits_pack_large: "24.99",
  premium_weekly: "9.99", premium_monthly: "29.99",
};
export const amountOf = (sku) => AMOUNTS[sku];

export const applePayAvailable = () => {
  try {
    return !!window.ApplePaySession && window.ApplePaySession.canMakePayments();
  } catch {
    return false;
  }
};

export const googlePayRequest = (cfg, sku) => ({
  apiVersion: 2,
  apiVersionMinor: 0,
  allowedPaymentMethods: [{
    type: "CARD",
    parameters: { allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"], allowedCardNetworks: ["AMEX", "MASTERCARD", "VISA"] },
    tokenizationSpecification: { type: "PAYMENT_GATEWAY", parameters: { gateway: "mollie", gatewayMerchantId: cfg.profile_id } },
  }],
  merchantInfo: { merchantName: "Love Connect +", ...(cfg.google_pay_merchant_id ? { merchantId: cfg.google_pay_merchant_id } : {}) },
  transactionInfo: { totalPriceStatus: "FINAL", totalPrice: amountOf(sku), currencyCode: "EUR", countryCode: "FR" },
});

let gpClient = null;
export const getGooglePayClient = async (testmode) => {
  await loadScript("https://pay.google.com/gp/p/js/pay.js");
  if (!gpClient) gpClient = new window.google.payments.api.PaymentsClient({ environment: testmode ? "TEST" : "PRODUCTION" });
  return gpClient;
};
